import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, func, number, shape, string,
} from 'prop-types'

function StyleGrid({ styles, selectedStyleId = undefined, onSelectStyle }) {
  return (
    <div className="style-panel__grid">
      {styles.map((style) => (
        <button
          key={style.id}
          type="button"
          aria-pressed={style.id === selectedStyleId}
          className={classnames(
            'style-panel__card',
            style.id === selectedStyleId && 'style-panel__card--selected',
          )}
          onClick={() => onSelectStyle(style)}
        >
          {/*
            A style with no cover uploaded yet fails to load; alt="" keeps Chrome from
            drawing a broken-image icon, so the card's own gradient shows through and no
            per-card error state is needed. Lazy because the grid is hundreds of remote covers.
          */}
          <img
            className="style-panel__card-image"
            src={style.image_url}
            alt=""
            loading="lazy"
            decoding="async"
          />
          <span className="style-panel__card-label cgt-caption-semibold">{style.name}</span>
        </button>
      ))}
    </div>
  )
}

StyleGrid.propTypes = {
  styles: arrayOf(shape({
    id: number.isRequired,
    name: string.isRequired,
    image_url: string.isRequired,
  })).isRequired,
  selectedStyleId: number,
  onSelectStyle: func.isRequired,
}

export default memo(StyleGrid)
